export const SET_LOADER = "SET_LOADER";
export const SET_REQUEST_LOADER = "SET_REQUEST_LOADER";
export const SET_UPDATE_ADDRESS_LOADER = "SET_UPDATE_ADDRESS_LOADER";
export const SET_ALERT_MESSAGE = "SET_ALERT_MESSAGE";
export const SET_STRIPE_INTENT_LOADER = "SET_STRIPE_INTENT_LOADER";

export const setLoader = ({ state, feature }) => ({
  type: `${feature} ${SET_LOADER}`,
  payload: state,
  meta: { feature },
});

export const setStripeIntentLoader = ({ state, feature }) => ({
  type: `${feature} ${SET_STRIPE_INTENT_LOADER}`,
  payload: state,
  meta: { feature },
});

export const setRequestLoader = ({ state, feature }) => ({
  type: `${feature} ${SET_REQUEST_LOADER}`,
  payload: state,
  meta: { feature },
});

export const setUpdateAddressLoader = ({ state, feature }) => ({
  type: `${feature} ${SET_UPDATE_ADDRESS_LOADER}`,
  payload: state,
  meta: { feature },
});

export const setAlertMessage = ({ state, feature }) => ({
  type: `${feature} ${SET_ALERT_MESSAGE}`,
  payload: state,
  meta: { feature },
});

export const closeAlertMessage = () => ({
  type: `${SET_ALERT_MESSAGE} CLOSE`,
  payload: {
    active: false,
    message: "",
    type: "",
  },
});

const initState = {
  isLoading: true,
  doingRequest: false,
  doingUpdateAddressRequest: false,
  stripeIntentLoading: false,
  alertMessage: {
    active: false,
    message: "",
    type: "",
  },
};

export const uiReducer = (ui = initState, action) => {
  switch (true) {
    case action.type.includes(SET_LOADER):
      return { ...ui, isLoading: action.payload };

    case action.type.includes(SET_REQUEST_LOADER):
      return { ...ui, doingRequest: action.payload };

    case action.type.includes(SET_UPDATE_ADDRESS_LOADER):
      return { ...ui, doingUpdateAddressRequest: action.payload };

    case action.type.includes(SET_ALERT_MESSAGE):
      return { ...ui, alertMessage: action.payload };

    case action.type.includes(SET_STRIPE_INTENT_LOADER):
      return { ...ui, stripeIntentLoading: action.payload };

    default:
      return ui;
  }
};
